import { call, put, takeEvery, takeLatest } from "redux-saga/effects";
import { getAxiosHeaders, getService } from "../../../library/RestAPI";
import {
  DECK_PAGE_SIZE,
  FETCH_DATA_CONTROL_FILES_DATA,
  fileInfoAPI,
  GET_DATA_CONTROL_CARD_SUMMARY,
  GET_DATA_CONTROL_DASHBOARD_SUMMARY,
  GET_DATA_CONTROL_USER_FILES_VIEW,
  GET_FILE_AUDIT_TRAIL,
  getDataControlCardSummaryAPI,
  getDataControlDashboardSummaryAPI,
  getFileAuditTrail,
  removePublicAccessAPI,
  removeUserAccessAPI,
  REVOKE_FILE_ACCESS,
  SET_DATA_CONTROL_CARD_SUMMARY,
  SET_DATA_CONTROL_DASHBOARD_SUMMARY,
  SET_DATA_CONTROL_FILES_DATA,
  SET_DATA_CONTROL_LOADER,
  SET_FILE_AUDIT_TRAIL,
  userInfoAPI,
  getUserAuditTrail,
  GET_USER_AUDIT_TRAILS,
  domainInfoAPI,
  GET_DATA_CONTROL_DOMAIN_FILES_VIEW,
  DATA_CONTROL_SNACKBAR,
  SET_USER_AUDIT_TRAILS,
  revokeDomainWideAccessAPI,
  SET_DOMAIN_AUDIT_TRAILS,
  GET_DOMAIN_AUDIT_TRAILS,
  getDomainAuditTrailAPI,
  userLocationInfoAPI,
  GET_USER_LOCATION_DATA,
  revokeUserLocationAccessAPI,
  GET_USER_LOCATION_AUDIT_TRAILS,
  fetchUserLocationAuditTrail,
  SET_USER_LOCATION_AUDIT_TRAIL,
} from "../DataControlConstans";

function* getCardSummarySaga(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const { cardName } = action.payload;
  const options = {
    method: "GET",
    url: getDataControlCardSummaryAPI(),
    params: {
      cardName,
    },
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response && response.status === 200) {
      yield put({
        type: SET_DATA_CONTROL_CARD_SUMMARY,
        payload: response?.data,
      });
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    console.log(error);
  }
}

function* getDashboardSummary() {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const options = {
    method: "GET",
    url: getDataControlDashboardSummaryAPI(),
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response && response.status === 200) {
      yield put({
        type: SET_DATA_CONTROL_DASHBOARD_SUMMARY,
        payload: response?.data,
      });
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    }
  } catch (error) {
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    console.log(error);
  }
}


function* fetchDataControlFileData(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const { size = DECK_PAGE_SIZE } = action.payload || {};
  try {
    const options = {
      method: "GET",
      url: fileInfoAPI({ page: 0, size }),
      headers: getAxiosHeaders(true),
    };

    const response = yield call(getService, options);

    if (response && response.status === 200) {
      const data = response.data;
      const alerts = data?.content || [];

      const summary = {
        totalFlagged: data.totalElements || 0,
        appliedRestrictions: 0,
        pendingReview: data.totalElements || 0,
        downloadsFlagged: data.totalElements || 0, // until backend provides download count
        highSeverity: alerts.filter((item) => item.alertSeverity === "HIGH")
          .length,
      };

      const items = alerts.map((item) => ({
        id: item.alertId,
        riskType: "FILE",

        title: item.fileName,
        subtitle: `Owned by ${item.actorName}`,
        description: `Owned by ${item.actorName} • Detected on ${new Date(
          item.detectedOn,
        ).toLocaleDateString()}.`,

        aiSummary: item.aiSummary,
        alertInfo: item.alertInfo,

        regulations: item.regulations,
        sensitivity: item.sensitivity,
        fileType: item.fileType,

        severity: item.alertSeverity,
        detectedOn: item.detectedOn,

        actions: ["Remove public access"],
        alertId: item.alertId,
        fileId: item.fileId,
        sensitivityId: item.sensitivityId,
        fileName: item.fileName,
        fileSeverity: item.fileSeverity,
        actorId: item.actorId,
        actorName: item.actorName,
        dataSourceId: item.dataSourceId,
        dataSourceName: item.dataSourceName,
        dataSourceType: item.dataSourceType,
      }));

      yield put({
        type: SET_DATA_CONTROL_FILES_DATA,
        payload: { categoryId: "public-sensitive", items, summary },
      });

      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    } else {
      console.log("Error fetching data control file data", response);
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err, "Please check the issue");
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
  }
}

function* fetchDataControlUserData(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const { size = DECK_PAGE_SIZE } = action.payload || {};
  try {
    const options = {
      method: "GET",
      url: userInfoAPI({ page: 0, size }),
      headers: getAxiosHeaders(true),
    };

    const response = yield call(getService, options);

    if (response && response.status === 200) {
      const data = response.data;
      const alerts = data?.content || [];

      const summary = {
        totalFlagged: data.totalElements || 0,
        appliedRestrictions: 0,
        pendingReview: data.totalElements || 0,
        downloadsFlagged: data.totalElements || 0,
        highSeverity: alerts.filter((item) => item.alertSeverity === "HIGH")
          .length,
      };

      const items = alerts.map((item) => ({
        id: item.userId,
        riskType: "USER",

        title: item.username,
        subtitle: `${item.dataSource} • ${item.dataSourceType}`,

        description: `Has ${item.exposedFiles} publicly shared file${
          item.exposedFiles !== 1 ? "s" : ""
        } with ${item.alertCount} risk alert${
          item.alertCount !== 1 ? "s" : ""
        }.`,

        aiSummary: item.aiSummary,

        severity: item.severity,
        detectedOn: item.lastDetected,

        actions: ["Remove public links"],
        userId: item.userId,
        userName: item.username,

        dataSourceId: item.dataSourceId,
        dataSource: item.dataSource,
        dataSourceType: item.dataSourceType,

        exposedFiles: item.exposedFiles,
        alertCount: item.alertCount,
        lastDetected: item.lastDetected,

        criticalFiles: item.criticalFiles,
        highFiles: item.highFiles,
        mediumFiles: item.mediumFiles,
        lowFiles: item.lowFiles,

        sensitiveFiles: item.sensitiveFiles,
        countriesExposed: item.countriesExposed,
        informationTypes: item.informationTypes,

        isPubliclyShared: item.isPubliclyShared,

        fileName: item.username,
      }));

      yield put({
        type: SET_DATA_CONTROL_FILES_DATA,
        payload: { categoryId: "user-risk", items, summary },
      });
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    } else {
      console.log("Error fetching data control file data", response);
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    }
  } catch (err) {
    console.log(err, "Please check the issue");
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
  }
}

function* fetchDataControlDomainData(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const { size = DECK_PAGE_SIZE } = action.payload || {};

  try {
    const options = {
      method: "GET",
      url: domainInfoAPI({ page: 0, size }),
      headers: getAxiosHeaders(true),
    };

    const response = yield call(getService, options);

    if (response && response.status === 200) {
      const data = response.data;
      const alerts = data?.content || [];

      const summary = {
        totalFlagged: data?.totalElements || 0,
        appliedRestrictions: 0,
        pendingReview: data?.totalElements || 0,
        downloadsFlagged: alerts.reduce(
          (total, item) => total + (item.alertsExposed || 0),
          0,
        ),
        highSeverity: alerts.filter((item) => item.riskLevel === "HIGH")
          .length,
      };

      const items = alerts.map((item) => ({
        id: item.dataSourceId,
        riskType: "DOMAIN",

        title: item.datasourceName,
        subtitle: item.dataSourceType,

        description: `${item.alertsExposed || 0} alert${
          item.alertsExposed !== 1 ? "s" : ""
        } exposed, affecting ${item.affectedUsers || 0} user${
          item.affectedUsers !== 1 ? "s" : ""
        }. Last detected on ${new Date(
          item.lastDetected,
        ).toLocaleDateString()}.`,

        aiSummary: item.aiSummary,

        severity: item.riskLevel,
        detectedOn: item.lastDetected,

        actions: ["Remove public access", "Restrict sharing"],

        dataSourceId: item.dataSourceId,
        dataSourceName: item.datasourceName,
        dataSourceType: item.dataSourceType,

        alertsExposed: item.alertsExposed,
        affectedUsers: item.affectedUsers,

        riskLevel: item.riskLevel,
        lastDetected: item.lastDetected,

        criticalFiles: item.criticalFiles,
        highFiles: item.highFiles,
        mediumFiles: item.mediumFiles,
        lowFiles: item.lowFiles,
        sensitiveFiles: item.sensitiveFiles,

        regulations: item.regulations,
        isPubliclyShared: item.isPubliclyShared,

        fileName: item.datasourceName,
      }));

      yield put({
        type: SET_DATA_CONTROL_FILES_DATA,
        payload: { categoryId: "org-wide", items, summary },
      });
    } else {
      console.log("Error fetching data control domain data", response);
    }
  } catch (err) {
    console.log(err, "Please check the issue");
  } finally {
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
  }
}

function* userLocationData(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const { size = DECK_PAGE_SIZE } = action.payload || {};

  try {
    const options = {
      method: "GET",
      url: userLocationInfoAPI({ page: 0, size }),
      headers: getAxiosHeaders(true),
    };

    const response = yield call(getService, options);

    if (response && response.status === 200) {
      const data = response.data;
      const alerts = data?.content || [];

      const summary = {
        totalFlagged: data?.totalElements || 0,
        appliedRestrictions: 0,
        pendingReview: data?.totalElements || 0,
        downloadsFlagged: 0,
        highSeverity: alerts.filter((item) => item.severity === "HIGH")
          .length,
      };

      const items = alerts.map((item) => ({
        id: item.userId,
        riskType: "USER_LOCATION",

        title: item.username,

        subtitle: `${item.dataSourceType} • ${item.countriesExposed || 0} ${
          item.countriesExposed === 1 ? "country" : "countries"
        } exposed`,

        description: `${item.countriesExposed || 0} ${
          item.countriesExposed === 1 ? "country" : "countries"
        } exposed from this user's activity.`,

        aiSummary: item.aiSummary,

        severity: item.severity || "HIGH",
        detectedOn: item.lastDetected,

        actions: ["Remove public access"],

        userId: item.userId,
        userName: item.username,

        dataSourceId: item.dataSourceId,
        dataSource: item.dataSource,
        dataSourceType: item.dataSourceType,

        exposedFiles: item.exposedFiles,
        alertCount: item.alertCount,

        countriesExposed: item.countriesExposed,
        countries: item.countries,

        sensitiveFiles: item.sensitiveFiles,
        criticalFiles: item.criticalFiles,
        highFiles: item.highFiles,
        mediumFiles: item.mediumFiles,
        lowFiles: item.lowFiles,

        lastDetected: item.lastDetected,

        fileName: item.username,
      }));

      yield put({
        type: SET_DATA_CONTROL_FILES_DATA,
        payload: { categoryId: "location", items, summary },
      });

      yield put({
        type: SET_DATA_CONTROL_LOADER,
        payload: false,
      });
    } else {
      console.log("Error fetching user location data", response);

      yield put({
        type: SET_DATA_CONTROL_LOADER,
        payload: false,
      });
    }
  } catch (err) {
    console.log(
      err,
      "Please check the issue while fetching user location data",
    );

    yield put({
      type: SET_DATA_CONTROL_LOADER,
      payload: false,
    });
  }
}


function* getDataControlFileAuditTrail(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const options = {
    method: "GET",
    url: getFileAuditTrail(),
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response && response?.status === 200) {
      const auditTrail = {
        rows: response?.data?.content.map((item) => ({
          id: item.id,
          timestamp: item.actionTakenTime,
          action: item.action,
          severity: "HIGH",
          fileName: item.fileName,
          source: item.source,
          scope: item.scope,
          reason: item.reason || "-",
          status: item.status || "Pending",
          actionTakenBy: item.actionTakenBy,
        })),
        total: response?.data?.totalElements,
        page: response?.data?.number,
        pageSize: response?.data?.size,
      };
      yield put({
        type: SET_FILE_AUDIT_TRAIL,
        payload: auditTrail,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    // yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
  }
}

function* getDataControlUserAuditTrails(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });
  const options = {
    method: "GET",
    url: getUserAuditTrail(),
    headers: getAxiosHeaders(true),
  };
  try {
    const response = yield call(getService, options);
    if (response && response?.status === 200) {
      const auditTrail = {
        rows:
          response?.data?.content?.map((item) => ({
            id: item.id,
            timestamp: item.actionTakenTime,
            action: item.action,
            severity: "HIGH",
            user: item.userName || item.username || "-",
            fileName: item.fileName,
            source: item.source,
            scope: item.scope,
            reason: item.reason || "-",
            status: item.status || "Pending",
            actionTakenBy: item.actionTakenBy,
          })) || [],

        total: response?.data?.totalElements || 0,
        page: response?.data?.number || 0,
        pageSize: response?.data?.size || 10,
      };
      yield put({
        type: SET_USER_AUDIT_TRAILS,
        payload: auditTrail,
      });
    }
  } catch (error) {
    console.log(error);
  } finally {
    // yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
  }
}

function* getDomainAuditTrails(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });

  const options = {
    method: "GET",
    url: getDomainAuditTrailAPI(),
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);

    if (response && response?.status === 200) {
      const data = response?.data;

      const auditTrail = {
        rows:
          data?.content?.map((item) => ({
            id: item.id,
            timestamp: item.actionTakenTime,
            action: item.action,
            severity: "HIGH",
            user: "-",
            fileName: item.fileName,
            source: item.source,
            scope: item.scope,
            reason: item.reason || "-",
            status: item.status || "Pending",
            actionTakenBy: item.actionTakenBy,
          })) || [],

        total: data?.totalElements || 0,
        page: data?.number || 0,
        pageSize: data?.size || 10,
      };

      yield put({
        type: SET_DOMAIN_AUDIT_TRAILS,
        payload: auditTrail,
      });
    }
  } catch (error) {
    console.log("Error fetching domain audit trail:", error);
  } finally {
    // yield put({
    //   type: SET_DATA_CONTROL_LOADER,
    //   payload: false,
    // });
  }
}

function* getUserLocationAuditTrail(action) {
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });

  const options = {
    method: "GET",
    url: fetchUserLocationAuditTrail(),
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);

    if (response && response.status === 200) {
      const data = response?.data;

      const auditTrail = {
        rows:
          data?.content?.map((item) => ({
            id: item.id,
            timestamp: item.actionTakenTime,
            action: item.action,
            severity: "HIGH",
            user: "-",
            fileName: item.fileName || "-",
            source: item.source || "-",
            scope: item.scope || "DISABLE_USER",
            reason: item.reason || "-",
            status: item.status || "Pending",
            actionTakenBy: item.actionTakenBy || "-",
          })) || [],

        total: data?.totalElements || 0,
        page: data?.number || 0,
        pageSize: data?.size || 10,
      };

      yield put({
        type: SET_USER_LOCATION_AUDIT_TRAIL,
        payload: auditTrail,
      });
    }
  } catch (error) {
    console.log("Error fetching user location audit trail:", error);
  } finally {
    // yield put({
    //   type: SET_DATA_CONTROL_LOADER,
    //   payload: false,
    // });
  }
}


function* revokeFileAccess(action) {
  const { fileIds, dataSourceId, openRiskId, size = DECK_PAGE_SIZE } =
    action.payload;
  yield put({ type: SET_DATA_CONTROL_LOADER, payload: true });

  const idsArray = Array.isArray(fileIds) ? fileIds : [fileIds];

  const getUrls = () => {
    if (openRiskId === "public-sensitive") {
      return removePublicAccessAPI(dataSourceId);
    } else if (openRiskId === "user-risk") {
      return removeUserAccessAPI(dataSourceId, idsArray);
    } else if (openRiskId === "org-wide") {
      return revokeDomainWideAccessAPI(dataSourceId);
    } else {
      return revokeUserLocationAccessAPI();
    }
  };

  const getSuccessMessage = () => {
    if (openRiskId === "public-sensitive") {
      return `Initiated revoking access for ${idsArray.length} file${idsArray.length !== 1 ? "s" : ""} successfully`;
    } else if (openRiskId === "user-risk") {
      return "Initiated revoking user access successfully";
    } else if (openRiskId === "org-wide") {
      return "Initiated revoking domain-wide access successfully";
    } else {
      return "Initiated revoking user location access successfully";
    }
  };

  const getErrorMessage = () => {
    if (openRiskId === "public-sensitive") {
      return "Error revoking file access";
    } else if (openRiskId === "user-risk") {
      return "Error revoking user access";
    } else if (openRiskId === "org-wide") {
      return "Error revoking domain-wide access";
    } else {
      return "Error revoking user location access";
    }
  };

  const getTableDataSaga = () => {
    if (openRiskId === "public-sensitive") return fetchDataControlFileData;
    if (openRiskId === "user-risk") return fetchDataControlUserData;
    if (openRiskId === "org-wide") return fetchDataControlDomainData;
    return userLocationData;
  };

  const sendData = () => {
    if (openRiskId === "location") {
      return {
        userIds: idsArray,
        dataSourceId: dataSourceId,
        actionFrom: "dataControl",
      };
    } else {
      return idsArray;
    }
  };

  const options = {
    method: openRiskId === "location" ? "POST" : "PUT",
    url: getUrls(),
    data: sendData(),
    headers: getAxiosHeaders(true),
  };

  try {
    const response = yield call(getService, options);
    if (response && (response?.status === 204 || response?.status === 200)) {
      yield call(getTableDataSaga(), { payload: { size } });
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
      yield put({
        type: DATA_CONTROL_SNACKBAR,
        payload: {
          success: true,
          successMessage: getSuccessMessage(),
          failure: false,
          failureMessage: "",
        },
      });
    } else {
      console.log("Error revoking file access", response);
      yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
      yield put({
        type: DATA_CONTROL_SNACKBAR,
        payload: {
          success: false,
          successMessage: "",
          failure: true,
          failureMessage: getErrorMessage(),
        },
      });
    }
  } catch (error) {
    console.log(error);
    yield put({ type: SET_DATA_CONTROL_LOADER, payload: false });
    yield put({
      type: DATA_CONTROL_SNACKBAR,
      payload: {
        success: false,
        successMessage: "",
        failure: true,
        failureMessage:
          "Something went wrong while revoking access. Please try again.",
      },
    });
  }
}

function* dataControlSaga() {
  yield takeEvery(GET_DATA_CONTROL_CARD_SUMMARY, getCardSummarySaga);
  yield takeEvery(GET_DATA_CONTROL_DASHBOARD_SUMMARY, getDashboardSummary);

  yield takeLatest(FETCH_DATA_CONTROL_FILES_DATA, fetchDataControlFileData);
  yield takeLatest(GET_DATA_CONTROL_USER_FILES_VIEW, fetchDataControlUserData);
  yield takeLatest(GET_DATA_CONTROL_DOMAIN_FILES_VIEW, fetchDataControlDomainData);
  yield takeLatest(GET_USER_LOCATION_DATA, userLocationData);

  yield takeEvery(REVOKE_FILE_ACCESS, revokeFileAccess);
  yield takeEvery(GET_FILE_AUDIT_TRAIL, getDataControlFileAuditTrail);
  yield takeEvery(GET_USER_AUDIT_TRAILS, getDataControlUserAuditTrails);
  yield takeEvery(GET_DOMAIN_AUDIT_TRAILS, getDomainAuditTrails);
  yield takeEvery(GET_USER_LOCATION_AUDIT_TRAILS, getUserLocationAuditTrail);
}

export default dataControlSaga;